import MemberFileAccessSelector from './MemberFileAccessSelector.component';

export default MemberFileAccessSelector;